import React from "react";
const MetricCard = ({ Icon, value, label }) => (
  <div className="bg-white p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition duration-300">
    <Icon className="w-10 h-10 text-blue-500 mx-auto mb-3" />
    <h3 className="text-3xl font-bold text-gray-800">{value}</h3>
    <p className="text-sm text-gray-600 mt-2">{label}</p>
  </div>
);
export default MetricCard;
